/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: ESM Woocommerce to Hubspot Integration
  Author: Wibert Muza
  Agency URL: https://esminbound.com
==========================================================================================*/

import navbarSearchAndPinList from "@/layouts/components/navbar/navbarSearchAndPinList"
import themeConfig from "@/../themeConfig.js"
import colors from "@/../themeConfig.js"

// /////////////////////////////////////////////
// Helper
// /////////////////////////////////////////////

// *From Auth - Data will be received from auth provider
const userDefaults = {
  uid: "UtS7TzQVfvQS8J3zCxYGjLcnCMZ2", // From Auth
  displayName: "sample user", // From Auth
  photoURL: require("@/assets/images/portrait/small/user.png"), // From Auth
  about:
    "Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.",
  status: "online",
  userRole: "admin",
  dashboardOrders: [],
  allErrors: 0,
  allOrders: 0,
  allCustomers: 0,
  revenueGenerated: 0,
  groupedOrders: [],
  goalOverview: {
    series: [0]
  },
  revenueSeries: [],
  ableyk: "vOY4YA.CpOMeA:O8XSr1WEGT0B_nM0",
  received: false,
  order: "order",
  deal: "deal",
  contact: "Contact",
  product: "Product",
  customer: "Customer",
  lineItem: "Line Item",
  hubspotTitle: "Hubspot Portal",
  hubspotConnection: "",
  woocommerceConnection: "",
  hubspotConnectionTitle: "Hubspot Connection",
  woocommerceTitle: "Woocommerce Store",
  woocommerceImage: require("@/assets/images/pages/woocommerce.jpg"),
  hubImage: require("@/assets/images/pages/hub.png"),
  wooImage: require("@/assets/images/pages/woo.png"),
  hubspotImage: require("@/assets/images/pages/hubspot.png"),
  cards: {
    wooStoreUrl: "https://example.com",
    wooActive: false,
    url: "https://example.com",
    portal_id: ".......",
    active: false,
    orderHistory: [],
    productHistory: [],
    customerHistory: [],
    orderErrors: [],
    productErrors: [],
    customerErrors: [],
    property_mappings: {
      enabled: false,
      webhookUri: null,
      mappings: {
        CONTACT: {
          properties: [
            {
              hubspotPropertyName: "firstname",
              label: "First Name",
              externalPropertyName: "first_name"
            },
            {
              hubspotPropertyName: "lastname",
              label: "Last Name",
              externalPropertyName: "last_name"
            },
            {
              hubspotPropertyName: "phone",
              label: "Phone Number",
              externalPropertyName: "phone"
            },
            {
              hubspotPropertyName: "email",
              label: "Email",
              externalPropertyName: "email"
            },
            {
              hubspotPropertyName: "city",
              label: "City",
              externalPropertyName: "city"
            },
            {
              hubspotPropertyName: "state",
              label: "State/Region",
              externalPropertyName: "state"
            },
            {
              hubspotPropertyName: "zip",
              label: "Postal Code",
              externalPropertyName: "postcode"
            },
            {
              hubspotPropertyName: "address",
              label: "Street Address",
              externalPropertyName: "address_1"
            },
            {
              hubspotPropertyName: "country",
              label: "Country/Region",
              externalPropertyName: "country"
            }
          ]
        },
        DEAL: {
          properties: [
            {
              hubspotPropertyName: "amount",
              label: "Amount",
              externalPropertyName: "total"
            },
            {
              hubspotPropertyName: "createdate",
              label: "Create Date",
              externalPropertyName: "date_created"
            },
            {
              hubspotPropertyName: "closedate",
              label: "Close Date",
              externalPropertyName: "date_modified"
            },
            {
              hubspotPropertyName: "dealname",
              label: "Deal Name",
              externalPropertyName: "name"
            },
            {
              hubspotPropertyName: "ip__ecomm_bridge__tax_amount",
              label: "Tax",
              externalPropertyName: "total_tax"
            },
            {
              hubspotPropertyName: "ip__ecomm_bridge__order_number",
              label: "Order Number",
              externalPropertyName: "id"
            },
            {
              hubspotPropertyName: "ip__ecomm_bridge__discount_amount",
              label: "Discount",
              externalPropertyName: "discount_total"
            },
            {
              hubspotPropertyName: "dealstage",
              label: "Deal Stage",
              externalPropertyName: "status"
            }
          ]
        },
        PRODUCT: {
          properties: [
            {
              externalPropertyName: "product_description",
              hubspotPropertyName: "description",
              label: "Product Description"
            },
            {
              externalPropertyName: "price",
              hubspotPropertyName: "price",
              label: "Price"
            },
            {
              externalPropertyName: "product_name",
              hubspotPropertyName: "name",
              label: "Product Name"
            },
            {
              externalPropertyName: "product_image",
              hubspotPropertyName: "ip__ecomm_bridge__image_url",
              label: "Product Image"
            }
          ]
        },
        LINE_ITEM: {
          properties: [
            {
              externalPropertyName: "tax_amount",
              hubspotPropertyName: "tax",
              label: "Tax"
            },
            {
              externalPropertyName: "num_items",
              hubspotPropertyName: "quantity",
              label: "Quantity"
            },
            {
              externalPropertyName: "price",
              hubspotPropertyName: "price",
              label: "Price"
            },
            {
              externalPropertyName: "discount_amount",
              hubspotPropertyName: "ip__ecomm_bridge__discount_amount",
              label: "Discount"
            }
          ]
        }
      }
    }
  },
  defaultState: {
    uid: "temp", // From Auth
    displayName: "sample user", // From Auth
    photoURL: require("@/assets/images/portrait/small/user.png"), // From Auth
    about:
      "Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.",
    status: "online",
    userRole: "admin",
    dashboardOrders: [],
    allErrors: 0,
    allOrders: 0,
    allCustomers: 0,
    revenueGenerated: 0,
    groupedOrders: [],
    goalOverview: {
      series: [0]
    },
    revenueSeries: [],
    ableyk: "vOY4YA.CpOMeA:O8XSr1WEGT0B_nM0",
    received: false,
    order: "order",
    deal: "deal",
    contact: "Contact",
    product: "Product",
    customer: "Customer",
    lineItem: "Line Item",
    hubspotTitle: "Hubspot Portal",
    hubspotConnection: "",
    woocommerceConnection: "",
    hubspotConnectionTitle: "Hubspot Connection",
    woocommerceTitle: "Woocommerce Store",
    woocommerceImage: require("@/assets/images/pages/woocommerce.jpg"),
    hubImage: require("@/assets/images/pages/hub.png"),
    wooImage: require("@/assets/images/pages/woo.png"),
    hubspotImage: require("@/assets/images/pages/hubspot.png"),
    cards: {
      wooStoreUrl: "https://example.com",
      wooActive: false,
      url: "https://example.com",
      portal_id: ".......",
      active: false,
      orderHistory: [],
      productHistory: [],
      customerHistory: [],
      orderErrors: [],
      productErrors: [],
      customerErrors: [],
      property_mappings: {
        enabled: false,
        webhookUri: null,
        mappings: {
          CONTACT: {
            properties: [
              {
                hubspotPropertyName: "firstname",
                label: "First Name",
                externalPropertyName: "first_name"
              },
              {
                hubspotPropertyName: "lastname",
                label: "Last Name",
                externalPropertyName: "last_name"
              },
              {
                hubspotPropertyName: "phone",
                label: "Phone Number",
                externalPropertyName: "phone"
              },
              {
                hubspotPropertyName: "email",
                label: "Email",
                externalPropertyName: "email"
              },
              {
                hubspotPropertyName: "city",
                label: "City",
                externalPropertyName: "city"
              },
              {
                hubspotPropertyName: "state",
                label: "State/Region",
                externalPropertyName: "state"
              },
              {
                hubspotPropertyName: "zip",
                label: "Postal Code",
                externalPropertyName: "postcode"
              },
              {
                hubspotPropertyName: "address",
                label: "Street Address",
                externalPropertyName: "address_1"
              },
              {
                hubspotPropertyName: "country",
                label: "Country/Region",
                externalPropertyName: "country"
              }
            ]
          },
          DEAL: {
            properties: [
              {
                hubspotPropertyName: "amount",
                label: "Amount",
                externalPropertyName: "total"
              },
              {
                hubspotPropertyName: "createdate",
                label: "Create Date",
                externalPropertyName: "date_created"
              },
              {
                hubspotPropertyName: "closedate",
                label: "Close Date",
                externalPropertyName: "date_modified"
              },
              {
                hubspotPropertyName: "dealname",
                label: "Deal Name",
                externalPropertyName: "name"
              },
              {
                hubspotPropertyName: "ip__ecomm_bridge__tax_amount",
                label: "Tax",
                externalPropertyName: "total_tax"
              },
              {
                hubspotPropertyName: "ip__ecomm_bridge__order_number",
                label: "Order Number",
                externalPropertyName: "id"
              },
              {
                hubspotPropertyName: "ip__ecomm_bridge__discount_amount",
                label: "Discount",
                externalPropertyName: "discount_total"
              },
              {
                hubspotPropertyName: "dealstage",
                label: "Deal Stage",
                externalPropertyName: "status"
              }
            ]
          },
          PRODUCT: {
            properties: [
              {
                externalPropertyName: "product_description",
                hubspotPropertyName: "description",
                label: "Product Description"
              },
              {
                externalPropertyName: "price",
                hubspotPropertyName: "price",
                label: "Price"
              },
              {
                externalPropertyName: "product_name",
                hubspotPropertyName: "name",
                label: "Product Name"
              },
              {
                externalPropertyName: "product_image",
                hubspotPropertyName: "ip__ecomm_bridge__image_url",
                label: "Product Image"
              }
            ]
          },
          LINE_ITEM: {
            properties: [
              {
                externalPropertyName: "tax_amount",
                hubspotPropertyName: "tax",
                label: "Tax"
              },
              {
                externalPropertyName: "num_items",
                hubspotPropertyName: "quantity",
                label: "Quantity"
              },
              {
                externalPropertyName: "price",
                hubspotPropertyName: "price",
                label: "Price"
              },
              {
                externalPropertyName: "discount_amount",
                hubspotPropertyName: "ip__ecomm_bridge__discount_amount",
                label: "Discount"
              }
            ]
          }
        }
      }
    }
  }
};


// Check if device is touch device
// This is used to remove perfect scrollbar from touch devices
// Using Dynamic components
const is_touch_device = () => {
  var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
  var mq = function(query) {
      return window.matchMedia(query).matches;
  }

  if (('ontouchstart' in window) || window.DocumentTouch) {
      return true;
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
  return mq(query);
}

// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
    AppActiveUser           : userDefaults,
    bodyOverlay             : false,
    isVerticalNavMenuActive : true,
    is_touch_device         : is_touch_device(),
    mainLayoutType          : themeConfig.mainLayoutType || "vertical",
    navbarSearchAndPinList  : navbarSearchAndPinList,
    reduceButton            : themeConfig.sidebarCollapsed,
    verticalNavMenuWidth    : "default",
    verticalNavMenuItemsMin : false,
    scrollY                 : 0,
    starredPages            : navbarSearchAndPinList["pages"].data.filter((page) => page.is_bookmarked),
    theme                   : themeConfig.theme || "light",
    themePrimaryColor       : colors.primary,

    // Can be used to get current window with
    // Note: Above breakpoint state is for internal use of sidebar & navbar component
    windowWidth: null,
}

export default state
